import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { Article } from "@/features/search/types/search";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const getMostRecentDate = (
  existingArticles: Article[]
): string | null => {
  if (!existingArticles?.length) {
    console.log("No existing articles");
    return null;
  }

  try {
    const validArticles = existingArticles.filter(
      (article) => article.publish_date
    );

    if (validArticles.length === 0) {
      console.log("No valid articles with dates");
      return null;
    }

    const mostRecent = validArticles.reduce<Date | null>((latest, article) => {
      const datePart = article.publish_date.split(" ")[0];
      const currentDate = new Date(datePart);

      if (!latest) return currentDate;
      return latest > currentDate ? latest : currentDate;
    }, null);

    if (!mostRecent) {
      console.log("No most recent date found");
      return null;
    }

    return mostRecent.toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  } catch (error) {
    console.error("Error processing dates:", error);
    return null;
  }
};
